import GoogleReview from "@/components/GoogleReview";
import { PrismicImage, PrismicLink } from "@prismicio/react";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.HeroStaticPageSlice} HeroStaticPageSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroStaticPageSlice>} HeroStaticPageProps
 * @param {HeroStaticPageProps}
 */
const HeroStaticPage = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-light-pink bg-coulure-static-hero relative"
    >
      <div className="lg:pt-[156px] pt-24 pb-16 lg:pb-32 px-4 md:px-7 lg:px-10 relative z-[10] max-w-[1400px] m-auto flex flex-col md:flex-row gap-4 md:gap-10">
        <div className="md:w-[70%]">
          <div className="md:mb-7">
            <PrismicRichText field={slice.primary.title}
              components={{ heading1: ({ children }) => (
                  <h1 className="h1-landing text-center md:text-start"> {children} </h1>),
              }}
            />
          </div>

          <div className="hidden md:block">
            <PrismicRichText field={slice.primary.text}
              components={{ paragraph: ({ children }) => (
                  <p className="p-landing"> {children} </p>),
              }}
            />
          </div>
          <div className="mt-[60px] mr-[35px] hidden md:block">
            <div className="button button-br-left overflow-hidden background-slide-white">
              <PrismicLink field={slice.primary.cta_page} className="button-text cta_form">
                {slice.primary.cta_label}</PrismicLink>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-[60%] m-auto md:w-[40%] relative">
          <PrismicImage field={slice.primary.picture} className="h-auto lg:h-[380px] w-full mb-2 object-contain"   loading={index === 0 ? '' : 'lazy'} />
          <div className="hidden md:block">
            <GoogleReview note={slice.primary.note} picto={slice.primary.picto} />
          </div>
          <div className="flex absolute md:hidden -right-10 bottom-0">
            <div
              className="bg-white bg-grain rounded-full w-[115px] h-[45px] flex flex-col items-center justify-center">
              <p className="text-google text-center -mb-1">
                {slice.primary.note}
              </p>
              <PrismicImage field={slice.primary.picto} className="w-[65px] h-[9px] object-contain"   loading={index === 0 ? '' : 'lazy'}/>
              <p className="text-google text-center -mt-1"> sur Google</p>
            </div>
          </div>
        </div>
        <div className="my-4 md:hidden">
            <PrismicRichText field={slice.primary.text}
              components={{ paragraph: ({ children }) => (
                  <p className="p-landing"> {children} </p>),
              }}
            />
          </div>
        <div className="text-center md:hidden">
          <div className="button button-br-left overflow-hidden background-slide-white">
            <PrismicLink field={slice.primary.cta_page} className="button-text cta_form">
              {slice.primary.cta_label}</PrismicLink>
          </div>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>
    </section>
  );
};

export default HeroStaticPage;
